import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { GetNotificationsOptions } from 'src/shared/schemas/stream/notification'

export const notifications = createQueryKeys('notifications', {
  list: (options?: Omit<GetNotificationsOptions, 'offset'>) => ({
    queryKey: [{ options }],
  }),
  detail: (notificationId: string) => [notificationId],
  markAsRead: null,
})
